import styled from "styled-components";
import { TextField } from "@material-ui/core";

export const STTextField = styled(TextField)`
  && {
    margin: 0px 0px 11px 0px;
  }
`;
